export const MAX_ROW_SELECTION_MSG = 'Maximum limit of 10 records reached';
export const SINGLE_ROW_SELECTION_MSG = 'Max limit Reached. Not more then 1 record can be selected.';
export const NO_DATA_FOUND_MSG = 'No data found';
export const INTERNAL_SERVER_ERR_MSG = 'Internal server error. Please try again';
